module.exports = __webpack_public_path__ + "static/media/leaf.7724bcc1.jpg";